import { useContext } from 'react';
import Categories from './Categories';
import { getLabConfig } from '../../utils/api';

import MenuContext from '../../store/MenuContext';
import CategoryMenuClasses from './CategoryMenu.module.css';

const CategoryMenu = () => {

	const menuTheme = useContext(MenuContext);
    return (
        <nav className={CategoryMenuClasses.categoriesmenu}>
            <Categories idPrefix='menu'/>
        </nav>
    );
};

export default CategoryMenu;